var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlueCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 15C0 6.71573 6.71573 0 15 0C23.2843 0 30 6.71573 30 15C30 23.2843 23.2843 30 15 30C6.71573 30 0 23.2843 0 15Z",
    fill: "#009CDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00003 19.6123C6.99888 19.7949 7.03041 19.9759 7.09279 20.1448C7.15518 20.3138 7.24717 20.4673 7.36343 20.5964C7.47969 20.7255 7.6179 20.8277 7.77002 20.8969C7.92214 20.9662 8.08515 21.0012 8.24956 21H20.8143C20.9791 21.0012 21.1425 20.9663 21.2951 20.8971C21.4477 20.828 21.5865 20.7259 21.7035 20.5969C21.8204 20.468 21.9132 20.3146 21.9766 20.1456C22.0399 19.9766 22.0725 19.7953 22.0725 19.6123V14.5048H7.00003V19.6123ZM12.0155 17.6368C12.0155 17.5447 12.0484 17.4565 12.107 17.3914C12.1656 17.3264 12.245 17.2898 12.3279 17.2898H15.8856C15.9684 17.2898 16.0479 17.3264 16.1065 17.3914C16.1651 17.4565 16.198 17.5447 16.198 17.6368V18.7931C16.198 18.8861 16.1654 18.9754 16.107 19.0419C16.0487 19.1085 15.9692 19.1472 15.8856 19.1497H12.3279C12.2443 19.1472 12.1648 19.1085 12.1065 19.0419C12.0481 18.9754 12.0155 18.8861 12.0155 18.7931V17.6368ZM8.66607 17.6368C8.66833 17.5439 8.70316 17.4556 8.76312 17.3908C8.82309 17.326 8.90346 17.2898 8.98713 17.2898H10.8701C10.9529 17.2898 11.0324 17.3264 11.091 17.3914C11.1496 17.4565 11.1825 17.5447 11.1825 17.6368V18.7931C11.1825 18.8861 11.1499 18.9754 11.0915 19.0419C11.0332 19.1085 10.9537 19.1472 10.8701 19.1497H8.98713C8.90267 19.1473 8.82228 19.1089 8.76254 19.0426C8.7028 18.9762 8.66827 18.8869 8.66607 18.7931V17.6368ZM22.0551 9.38772V10.785H7.00003V9.38772C6.99888 9.20513 7.03041 9.0241 7.09279 8.85516C7.15518 8.68622 7.24717 8.53273 7.36343 8.40361C7.47969 8.2745 7.6179 8.17234 7.77002 8.10305C7.92214 8.03377 8.08515 7.99875 8.24956 8.00003H20.8143C21.1442 8.00258 21.4598 8.14991 21.6922 8.40988C21.9247 8.66984 22.0551 9.02135 22.0551 9.38772Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -1.25,
    y1: 15,
    x2: 31.6694,
    y2: 16.6287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8E6FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.983871,
    stopColor: "#009CDE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCard);
export default __webpack_public_path__ + "static/media/blue-card.2420e92dbe8fbd226442a8329c702a73.svg";
export { ForwardRef as ReactComponent };